import { render } from "./DataUploader.vue?vue&type=template&id=f672cdfe&scoped=true"
import script from "./DataUploader.vue?vue&type=script&lang=js"
export * from "./DataUploader.vue?vue&type=script&lang=js"

import "./DataUploader.vue?vue&type=style&index=0&id=f672cdfe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f672cdfe"]])

export default __exports__